<template>
  <div v-show="canvasCurrentView === 'fluxogram'">
    <div class="klickbox-fluxogram-holder">
      <div class="klickbox-fluxogram-container"></div>
    </div>
    <a class="button_close" @click="canvasChangeView('steps')"><i class="fa fa-times"></i> {{ $t('general.actions.close') }}</a>
    <div class="flow_button flow_button__zoom">
      <a class="flow_button__zoom-btn" @click="fluxogramZoomIn()"><i class="fa fa-search-plus"></i></a>
      <a class="flow_button__zoom-btn" @click="fluxogramZoomOut()"><i class="fa fa-search-minus"></i></a>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Fluxogram from '../../../../helpers/fluxogram';

const fluxogram = new Fluxogram();
const holderNodeClass = '.klickbox-fluxogram-container';

let graph = null;

export default {
  updated() {
    if (this.canvasCurrentView !== 'fluxogram') {
      return;
    }

    const holderNode = this.$el.querySelector(holderNodeClass);

    graph = fluxogram.build(this.steps, holderNode);
  },
  methods: {
    fluxogramZoomIn() {
      graph.api.pan.zoomIn();
    },
    fluxogramZoomOut() {
      graph.api.pan.zoomOut();
    },
    ...mapActions([
      'canvasChangeView',
    ]),
  },
  computed: mapGetters({
    canvasCurrentView: 'canvasCurrentView',
    steps: 'stepList',
  }),
};
</script>



/** WEBPACK FOOTER **
 ** Main.vue?7bd2b832
 **/